// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__v4-0z","header__Title":"styles_header__Title__QIksl"};